<template lang="pug">
  #app(:class="{'mobile-menu-mask' : isMobile, 'on' : isMobile && navToggle}")
    vue-header(v-if="!isMobile && !noLayout",
               :navHeight.sync="fullScreenCount.navHeight",
               :isMobile="isMobile",
               :isLogin.sync="isLogin",
               :navToggle.sync="navToggle")
    vue-header-mobile(v-if="isMobile && !noLayout",
                      :navHeight.sync="fullScreenCount.navHeight",
                      :fullScreenCount="fullScreenCount",
                      :isMobile="isMobile",
                      :isPortrait="isPortrait",
                      :isLogin.sync="isLogin",
                      :navToggle.sync="navToggle")
    .site-content(:style="{paddingBottom: $route.meta.mobileBtn && isMobile? '48px' : '0px'}")
      router-view(:style="{paddingTop: navPaddingCount()}",
                  :fullScreenCount="fullScreenCount",
                  :isMobile="isMobile",
                  :isPortrait="isPortrait",
                  :isLogin="isLogin")
    vue-footer(v-if="!noLayout", :isMobile="isMobile", :style="{paddingBottom: $route.meta.mobileBtn && isMobile? '48px' : '0px'}")
    //- .console
      li clientHeight: {{ fullScreenCount.clientHeight }}
      li navHeight: {{ fullScreenCount.navHeight }}
      li innerHeight: {{ fullScreenCount.innerHeight }}
      li sectionHeight: {{ fullScreenCount.sectionHeight }}
      li isMobile: {{ isMobile }}
</template>

<script>
import { mapActions } from 'vuex'
import vueHeader from './components/layouts/vueHeader.vue'
import vueHeaderMobile from './components/layouts/vueHeaderMobile.vue'
import vueFooter from './components/layouts/vueFooter.vue'
export default {
  metaInfo () {
    return {
      title: this.$route.meta.title,
      titleTemplate: '%s | WirForce 2017 - 4Gamers',
      changed (newInfo, addedTags, removedTags) {
        console.log('Meta info was updated!')
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      let accessToken = window.localStorage.getItem('accessToken')
      if (accessToken) {
        this.isLogin = true
        this.fetchUserInfo(accessToken)
      }
    })
  },
  components: {
    'vueHeader': vueHeader,
    'vueHeaderMobile': vueHeaderMobile,
    'vueFooter': vueFooter
  },
  data () {
    return {
      fullScreenCount: {
        clientHeight: Number,
        navHeight: Number,
        innerHeight: window.innerHeight,
        innerWidth: window.innerWidth,
        sectionHeight: Number
      },
      isMobile: false,
      isPortrait: false,
      isLogin: false,
      noLayout: false,
      navToggle: false
    }
  },
  methods: {
    ...mapActions(['fetchUserInfo']),
    nowOrientation () {
      if (window.orientation && window.orientation === -90) {
        this.isPortrait = true
      } else {
        this.isPortrait = false
      }
    },
    // Count independent section's height
    setSectionHeight () {
      // 頁面高度
      this.fullScreenCount.clientHeight = this.$el.clientHeight
      // 視窗高度
      this.fullScreenCount.innerHeight = window.innerHeight
      this.fullScreenCount.innerWidth = window.innerWidth
      // Section高度
      if (this.isMobile === false) {
        this.fullScreenCount.sectionHeight = this.fullScreenCount.innerHeight - this.fullScreenCount.navHeight + 33
      } else {
        this.fullScreenCount.sectionHeight = this.fullScreenCount.innerHeight - 30
      }
      // Update 頁面高度
      let section = document.getElementsByClassName('full-screen')
      // 計算 section 高度
      for (var i = 0; i < section.length; i++) {
        section[i].style.height = this.fullScreenCount.sectionHeight + 'px'
      }
    },
    diviceTest () {
      var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
      // var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || w <= 640) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    navPaddingCount () {
      if (this.isMobile === false) {
        return this.fullScreenCount.navHeight - 33 + 'px'
      } else {
        return 30 + 'px'
      }
    }
  },
  created () {
    if (process.env.NODE_ENV === 'production') {
      window.console.log = function () {}
    }
  },
  mounted () {
    this.diviceTest()
    this.setSectionHeight()
    this.navPaddingCount()
    if ('removeEventListener' in window) {
      window.addEventListener('resize', () => {
        this.diviceTest()
        this.setSectionHeight()
        this.navPaddingCount()
      }, false)
    }
    window.addEventListener('orientationchange', () => {
      this.nowOrientation()
    }, false)
    this.nowOrientation()
  },
  watch: {
    '$route.meta': function (meta) {
      console.log('meta: ', this.$route.meta)
      if (this.$route.meta.noLayout === true) {
        console.log('meta: ', this.$route.meta)
        this.$nextTick(() => {
          this.noLayout = true
        })
      } else {
        this.$nextTick(() => {
          this.noLayout = false
        })
      }
    },
    '$route.path': function () {
      this.navToggle = false
    }
  },
  updated () {
    let accessToken = window.localStorage.getItem('accessToken')
    if (accessToken) {
      this.isLogin = true
      this.fetchUserInfo(accessToken)
    }
    if (this.$route.meta.noLayout === true) {
      console.log('meta: ', this.$route.meta)
      this.noLayout = true
    } else {
      this.noLayout = false
    }
    // console.log('isLogin?', this.isLogin)

    console.log('Props Updated')
  },
  beforeDestroy () {
    if ('removeEventListener' in window) {
      window.addEventListener('resize', () => {
        this.diviceTest()
        this.setSectionHeight()
        this.navPaddingCount()
      }, false)
    }
    window.addEventListener('orientationchange', () => {
      this.nowOrientation()
    }, false)
  }
}
</script>

<style lang="sass">
@import '~stylesheets/variables'
@import '~stylesheets/mixin'
@import '~stylesheets/swal'
*
  font-family: "Helvetica Neue", "Helvetica", "Arial", "SF Pro TC", "PingFang TC", "微軟正黑體", "Microsoft JhengHei", sans-serif
  -webkit-font-smoothing: antialiased
  &::selection
    color: $red
h1, h2, h3, h4
  &::selection
    color: #fff
    text-shadow: 3px 3px 0 $red
.no-select
  user-select: none !important
  cursor: default
.v-select
  width: 260px
  display: inline-block
  background-color: $black
  @media screen and (max-width: 990px)
    width: 100%
  input[type=search], .v-select input[type=search]:focus
    color: #fff
  .dropdown-toggle
    border: 1px solid $grey !important
  &.searchable .dropdown-toggle, input
    cursor: pointer
  .selected-tag
    background-color: $red
    color: #fff
    border: none
    & + input.form-control
      position: absolute
      left: 0
      &:focus
        // position: relative
  &.open
    .selected-tag
      // display: none
      & + input.form-control
        position: relative
        float: left
  .open-indicator:before
    border-color: $grey
  .dropdown-menu
    background-color: $black
    li
      a
        color: #fff
      &.active
        background-color: $red
        a
          color: #fff
.console
  position: fixed
  z-index: 999
  right: 0
  bottom: 0
  background-color: rgba($grey-dark,0.9)
  padding: 16px
  list-style: none
  color: #fff
  input
    background-color: $black
    border: 1px solid $grey
    padding: 1px 3px
    margin: 0 3px
#app
  background-color: #12161e
  display: flex
  // flex-flow: stretch
  min-height: 100vh
  flex-direction: column
  color: #fff
  .site-content
    flex: 1
.container
  margin-top: 50px
.center-container
  width: 1920px !important
  margin: 0 auto
  max-width: calc(100% - 300px)
hr
  border-top: 1px solid $grey-dark
section
  position: relative
  .section-title
    position: relative
    color: $red
    font-size: 26px
    font-weight: bold
    &:after
      margin:
        top: 8px
        bottom: 32px
      position: relative
      content: ''
      width: 100%
      height: 1px
      display: block
      background: linear-gradient(to right, rgba(224,37,62,1) 0%, rgba(224,37,62,0.8) 40%, rgba(224,37,62,0) 50%)
  .title-decoration
    margin: 64px 0 32px 0
    text-align: center
    @extend %clearfix
    .dot
      display: inline-block
      width: 6px
      height: 6px
      margin: 3px 16px
      &:nth-child(1)
        background-color: $red
      &:nth-child(2)
        background-color: #20a896
      &:nth-child(3)
        background-color: #c1f329
      &:nth-child(4)
        background-color: #eea423
  h1
    text-align: center
    margin-bottom: 32px
  p
    color: $grey
    max-width: 70%
    margin: 0 auto
    margin-bottom: 128px
    @media screen and (max-width: 640px)
      max-width: 100%
      margin-bottom: 64px
.mobile-menu-mask
  &:after
    content: ""
    display: none
    position: fixed
    top: 0
    left: 0
    width: 100%
    height: 100%
    background-color: rgba(#000, 0.75)
    +opacity(0)
    +transition(opacity, 0.3s, ease)
  &.on
    height: 100vh
    overflow: hidden
    &:after
      display: block
      +opacity(1)
.bg-page
  background:
    image: url('~assets/bg-section02.png'), url('~assets/bg-dot.png')
    repeat: no-repeat, repeat-y
    position: bottom left, center center
    size: auto, 80% auto
  // min-height: calc( 100vh - 33px )
  min-height: 100vh

.btn-wrap
  @extend %clearfix
  .pre-btn
    float: left
    margin:
      top: 16px
      bottom: 32px
    @media screen and (max-width: 640px)
      float: none
  .next-btn
    float: right
    margin:
      top: 16px
      bottom: 32px
    @media screen and (max-width: 640px)
      float: none

.fixed-btn-wrap
  position: fixed
  bottom: 0
  width: 100%
  @extend %clearfix
  .fixed-btn
    position: relative
    width: 33.3333%
    float: left
    text-align: center
    background-color: $red
    color: #fff
    padding: 14px
    &:hover, &:focus, &:active
      color: #fff
      text-decoration: none
    &:active
      box-shadow: inset 0 0 34px 5px rgba(#000, 0.5)

.ghost-btn
  color: #fff
  border: 1px solid #fff
  padding: 8px 20px
  +border-radius(999px)
  +transition(all, 0.2s, ease)
  &:focus
    color: #fff
    border: 1px solid #fff
  &:hover, &:active
    color: $black
    background-color: #fff
  &.disabled, &[disabled]
    cursor: not-allowed
    color: #888
    border-color: #888
    &:hover, &:active, &:focus
      color: #888
      background-color: transparent
  @media screen and (max-width: 640px)
    display: block
  &.red
    color: $red
    border: 1px solid $red
    padding: 8px 20px
    &:focus
      color: $red
      border: 1px solid $red
    &:hover, &:active
      color: $black
      background-color: $red
    &.disabled, &[disabled]
      cursor: not-allowed
      color: #888
      border-color: #888
      &:hover, &:active, &:focus
        color: #888
        background-color: transparent

.link-red
  display: inline-block
  padding: 1px 3px 0 3px
  color: $red
  &:hover, &:focus
    color: $red

.spinner
  margin: 0 auto
  width: 100%
  text-align: center
  .text
    margin-right: 5px
  .bounce
    width: 6px
    height: 6px
    margin: 2px 2px
    background-color: #fff
    border-radius: 100%
    display: inline-block
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both
    animation: sk-bouncedelay 1.4s infinite ease-in-out both
  .bounce1
    -webkit-animation-delay: -0.32s
    animation-delay: -0.32s
  .bounce2
    -webkit-animation-delay: -0.16s
    animation-delay: -0.16s
  &.large
    .text
      font-size: 18px
      font-weight: bold
      margin-right: 0
      margin-bottom: 20px
      display: block
    .bounce
      width: 16px
      height: 16px
      margin: 2px 8px
  &.center
    background-color: rgba(#000, 0.3)
    padding: 80px
    position: fixed
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)

.tab-wrap
  border: 
    top: 1px solid $grey
    bottom: 1px solid $grey
  text-align: center
  .tab-item
    display: inline-block
    color: $grey
    padding: 16px 20px
    font-size: 16px
    font-weight: bold
    position: relative
    cursor: pointer
    &.actived
      color: #fff
    &:hover
      color: $red
    &:not(:last-child)
      &:after
        position: absolute
        content: ''
        width: 1px
        height: 40%
        background-color: $grey
        right: 0
        top: 30%
    @media screen and (max-width: 767px)
      display: block
      &:after
        display: none

.icon-logo
  display: inline-block
  background:
    image: url('~assets/logo-solid.svg')
    repeat: no-repeat
    position: 0 2px
  width: 26px
  height: 14px
.icon-logo-o
  display: inline-block
  background:
    image: url('~assets/logo-frame.svg')
    repeat: no-repeat
    position: 0 2px
  width: 26px
  height: 14px
  top: 2px

.em-title
  position: relative
  margin-left: 32px
  .icon-logo, .icon-logo-o
    margin-right: 6px
    position: absolute
    left: -32px
    top: 1px
  .text
    font-size: 14px
  & + .content
    color: $grey
    margin-left: 32px
    ul
      padding-left: 0
    li
      list-style: none
.paragraph-wrap
  margin-bottom: 32px
.gm-style .gm-style-iw
  color: $red
  font-weight: bold
.program-list
  display: block
  @extend %clearfix
  .list
    padding: 2px !important
    text-align: center
    margin-bottom: 32px
    .list-head
      font-size: 16px
      color: #fff
      padding: 16px 32px
    .list-content
      padding: 0 8px
      ul
        background-color: #2B2E36
        list-style: none
        padding: 0
        li
          padding: 25px
          &:first-child
            padding-top: 10px
          .time
            font-size: 20px
            margin-bottom: 4px
          .title
            font-size: 14px
            color: #fff
        &:empty
          &:after
            display: block
            content: '敬請期待'
            padding: 20px
            font-size: 20px
            font-weight: bold
            color: $grey-dark
    &:nth-child(1)
      .list-head
        background-color: rgba($red, 0.3)
        border: 1px solid $red
      .list-content
        border-bottom: 3px solid $red
        .time
          color: $red
    &:nth-child(2)
      .list-head
        background-color: rgba(#20a896, 0.3)
        border: 1px solid #20a896
      .list-content
        border-bottom: 3px solid #20a896
        .time
          color: #20a896
    &:nth-child(3)
      .list-head
        background-color: rgba(#9fd008, 0.3)
        border: 1px solid #9fd008
      .list-content
        border-bottom: 3px solid #9fd008
        .time
          color: #9fd008
    &:nth-child(4)
      .list-head
        background-color: rgba(#eea423, 0.3)
        border: 1px solid #eea423
      .list-content
        border-bottom: 3px solid #eea423
        .time
          color: #eea423
.tickets-warning
  position: relative
  text-align: center
  border: 1px solid $red
  background-color: $black
  padding: 0 16px
  +border-radius(8px)
  color: $red

.fullscreen-v-img
  z-index: 9999 !important
  </style>



// WEBPACK FOOTER //
// App.vue?682c135d